import React from "react";

import SkewBg from "../../Utils/SkewBg";
import PageHeader from "../../Utils/PageHeader";
import Avatar from "./Avatar";
import { AboutWrapper, AboutInfo } from "./About.styles";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";

const About = () => {
  const { mode } = React.useContext(ThemeContext);

  return (
    <AboutWrapper id="about">
      <PageHeader theme={mode}>About Me</PageHeader>
      <SkewBg theme={mode} />
      <AboutInfo>
        <div>
          <Avatar src="https://i.redd.it/dh5otp8kcf741.png" />
        </div>
        <p>
          Hi, I'm <b>Rohan Kumar Baranwal</b>, a passionate Full-stack web
          developer from India, currently working at Masai as an Instructional
          Associate. I tend to make use of modern web technologies to build
          websites that look great, feel fantastic, and function correctly. I am
          especially focusing on Reactjs.
          <br />
          <br />
          Strong in design and integration with intuitive problem-solving
          skills. Passionate about implementing and launching new projects.
          Ability to translate business requirements into technical solutions.
          Looking to start my career as an entry-level software engineer with a
          reputed firm driven by technology.
        </p>
      </AboutInfo>
    </AboutWrapper>
  );
};

export default About;
